import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`ImageMagick`}</h1>
    <p><inlineCode parentName="p">{`convert`}</inlineCode>{` is how you access imagemagick through cli`}</p>
    <h3>{`Resize all images in a folder`}</h3>
    <p><inlineCode parentName="p">{`convert *.jpg -resize 1024X1024 -set filename:f '%t' '%[filename:f].jpg'`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      